module.exports = __webpack_public_path__ + "static/media/memories_12.e848ef87.jpg";